import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {Svg} from '@modifi/ui'

const propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
}
const defaultProps = {
  color: 'currentColor',
  width: 16,
  height: 16,
}

type ShipIconProps = InferPropTypes<typeof propTypes, typeof defaultProps>

const ShipIcon: React.FC<ShipIconProps> = ({color, ...restProps}) => (
  <Svg viewBox="0 0 40 15" {...restProps}>
    <g fill="none" fillRule="evenodd">
      <g fill={color} stroke="#64BB00">
        <g>
          <g>
            <path
              d="M2 4.734L4.492 0 8 0 8 7 2 7zM2 12L34.79 12 37 7 8.064 7.21 0 7.254zM8 7L26 7 26 4 8 4z"
              transform="translate(-328 -368) translate(81 325) translate(248 44)"
            />
          </g>
        </g>
      </g>
    </g>
  </Svg>
)

ShipIcon.propTypes = propTypes
ShipIcon.defaultProps = defaultProps

export default ShipIcon
